function switchTab(tabId, shouldUpdateHash = true) {
  // 全てのタブボタンから active クラスを削除
  const buttons = document.querySelectorAll('.tab-button');
  buttons.forEach(btn => btn.classList.remove('active'));

  // 全てのコンテンツを非表示にする
  const contents = document.querySelectorAll('.tab-content');
  contents.forEach(content => content.classList.remove('active'));

  // クリックされたボタンに active クラスを追加
  document.getElementById('tab-' + tabId).classList.add('active');

  // 対応するコンテンツを表示
  document.getElementById(tabId).classList.add('active');

  // コーディネート、スタッフタブのときだけ一括削除ボタンを非表示
  const favoriteProductsContainer = document.querySelector('.favorite-products-container');
  if (favoriteProductsContainer) {
    favoriteProductsContainer.dataset.activeTab = tabId;
  }

  if (shouldUpdateHash) {
    // ユーザー操作時のみハッシュを更新して、初期表示時の意図しないスクロールを防ぐ
    history.replaceState(null, '', '#' + tabId);
  }
}

window.normalizeFavoriteProductTabContent = function () {
  document.querySelectorAll('#list-favorite .favorite-products__tags').forEach((tagContainer) => {
    const tagList = tagContainer.querySelector('.favorite-products__tags__list');
    const hasTags = Boolean(tagList && tagList.children.length > 0);

    tagContainer.classList.toggle('favorite-products__tags--empty', !hasTags);
    if (!hasTags) {
      tagContainer.setAttribute('aria-hidden', 'true');
    } else {
      tagContainer.removeAttribute('aria-hidden');
    }
  });

  const activeContent = document.querySelector('.tab-content.active');
  if (!activeContent || activeContent.id !== 'list-favorite') {
    return;
  }

  requestAnimationFrame(() => {
    switchTab('list-favorite', false);
  });
};

function preventWishlistSelfNavigation() {
  if (window.location.pathname !== '/pages/wishlist') {
    return;
  }

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0) {
      return;
    }

    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    const link = event.target.closest('a[href]');
    if (!link) {
      return;
    }

    const url = new URL(link.href, window.location.origin);
    if (
      url.origin === window.location.origin
      && url.pathname === '/pages/wishlist'
      && url.search === ''
      && url.hash === ''
    ) {
      event.preventDefault();
    }
  });
}

document.addEventListener("DOMContentLoaded",function(){
  const hash = window.location.hash;
  let tabId = 'list-favorite';
  if (hash === '#coordinate') {
    tabId = 'coordinate';
  } else if (hash === '#list-favorite') {
    tabId = 'list-favorite';
  } else if (hash === '#staff') {
    tabId = 'staff';
  }
  preventWishlistSelfNavigation();
  switchTab(tabId, false);
});
